import {
  animate,
  keyframes,
  style,
  transition,
  trigger,
} from '@angular/animations';

// Tiré et adapté de Animista
export const slideInTopAnimation = trigger('slideInTopAnimation', [
  transition(':enter', [
    animate(
      '0.3s cubic-bezier(.25, .46, .45, .49)',
      keyframes([
        style({
          transform: 'translateY(-1000px)',
          opacity: 0,
        }),
        style({
          transform: 'translateY(0)',
          opacity: 1,
        }),
      ]),
    ),
  ]),
  transition(':leave', [
    animate(
      '1s cubic-bezier(.25, .46, .45, .49)',
      keyframes([
        style({
          transform: 'translateY(0)',
          opacity: 1,
        }),
        style({
          transform: 'translateY(-1000px)',
          opacity: 0,
        }),
      ]),
    ),
  ]),
]);
